export default __webpack_public_path__ + "static/media/seguisb.6e8b789f.ttf";